export default __webpack_public_path__ + "ionic.734d1fb5.png";